<!-- <ngx-ui-loader></ngx-ui-loader>
<!-- router -->
<!-- <router-outlet></router-outlet> --> 

<ng-container *ngIf="bootReady; else splash">
   
  <router-outlet></router-outlet>
   <ngx-ui-loader></ngx-ui-loader>
</ng-container>

<ng-template #splash>
 <div class="boot-loader">
  <div class="spinner"></div>
  <div class="text">Loading...</div>
</div>
</ng-template>
